import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import InfoBox from 'commonComponents/InfoBox/InfoBox';
import styles from './OurSuccessGuarantee.module.scss';

const OurSuccessGuarantee = ({ headers, boxes, info }) => {
  return (
    <BaseSection
      { ...headers }
      anchor='our-seccess-guarantee'
    >
      { boxes && <Boxes boxes={ boxes } /> }
      <InfoBox { ...info } />
    </BaseSection>
  );
};

const Boxes = ({ boxes }) => (
  <div className={ styles.boxes }>
    { boxes.map(box => <Box key={ box.title } { ...box } />) }
  </div>
);

const Box = ({ logo, title, text }) => {
  return (
    <div className={ styles.Box }>
      <img src={ logo } />
      <h5 className={ styles.header }>{ title }</h5>
      <p>{ text }</p>
    </div>
  );
};
 
export default OurSuccessGuarantee;
